export default "__VITE_ASSET__2f9e53f9__"